module.exports = __webpack_public_path__ + "static/frost_druid-d23ec9c28896a8f32be7e1a31eada907.jpeg";